import { createContext } from "react";
import { Dispatch } from "react";

export interface LocationState {
  locations: any[];
  location: any;
  error: any;
  loading: boolean;
  total: number;
}
export interface IContext {
  location: LocationState;
  getLocations: any;
  locationDispatch: Dispatch<any>;
}

export const initialLocation = {};

const LocationContext = createContext(initialLocation as IContext);

export default LocationContext;
